import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'

import StepperLine from './StepperLine'
import StepperAvatar from './StepperAvatar'

const SingleStepper = ({
  active,
  disableLine,
  name,
  date,
  imgUrl,
  sxTextContainer,
  activeSubtitle = 'Approved',
  inactiveSubtitle = 'Waiting submission',
  lastActiveSubtitle = 'Approved',
  lastInactiveSubtitle = 'Waiting submission',
  lastIndex,
  isRejected,
}) => {
  const namesConstructor = (arr) => {
    if (!Array.isArray(arr)) {
      return arr
    } else if (arr.length === 2 && Array.isArray(arr)) {
      return arr.map((item, index, name) => `${item} ${name.length - 1 === index ? '' : 'or '}`)
    } else if (arr.length > 2 && Array.isArray(arr)) {
      return <Typography component="span">{`${arr[0]} or ${arr.length - 1} others`}</Typography>
    } else {
      return arr
    }
  }

  return (
    <Box width={1}>
      <Box width={1} display="flex" alignItems="center" columnGap={1.4}>
        <Box
          height="52px"
          width="52px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="relative"
        >
          <StepperAvatar imgUrl={imgUrl} name={name} active={active} />
        </Box>
        <Box maxWidth={300} sx={{ ...sxTextContainer }}>
          <Typography variant="body1" color="dark-text.main" mb={0.3} noWrap width={1}>
            {namesConstructor(name)}
          </Typography>
          <Box display={'flex'} alignItems={'center'} columnGap={1}>
            {active || isRejected ? (
              <>
                {isRejected ? (
                  <Typography
                    noWrap
                    component="span"
                    variant="body2"
                    color="error.main"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    Rejected
                  </Typography>
                ) : (
                  <Typography
                    noWrap
                    component="span"
                    variant="body2"
                    color="alternate.main"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    {lastIndex ? lastActiveSubtitle : activeSubtitle}
                  </Typography>
                )}
                <Icon sx={{ fontSize: 5, color: 'light-gray-text.main' }}>circle_rounded</Icon>
              </>
            ) : null}
            <Typography noWrap component="span" variant="body2" color="light-gray-text.main">
              {active || isRejected ? date : lastIndex ? lastInactiveSubtitle : inactiveSubtitle}
            </Typography>
          </Box>
        </Box>
      </Box>
      {!disableLine && <StepperLine active={active} />}
    </Box>
  )
}

export default SingleStepper
